var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('div',{staticClass:"container",staticStyle:{"min-height":"600px","max-height":"1000px"}},[_c('v-flex',{attrs:{"xs12":"","text-xs-center":""}},[_c('VueFaqAccordion',{attrs:{"items":_vm.myItems}})],1)],1),_c('subFooter')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header"},[_c('h1',[_vm._v("HIROAPY")]),_c('h2',[_vm._v("Questions Fréquentes")])])
}]

export { render, staticRenderFns }